import { useState, useEffect } from 'react'
import {
  DEFAULT_BA_PER_MISSION,
  DEFAULT_BA_PAY_ADJUSTMENT,
} from '../../../options'

export const useStepResultsState = (initialData, isEdit) => {
  const [openedRow, setOpenedRow] = useState(null)
  const [baPerMission, setBaPerMission] = useState(DEFAULT_BA_PER_MISSION)
  const [payAdjustment, setPayAdjustment] = useState(DEFAULT_BA_PAY_ADJUSTMENT)
  const [modalProps, setModalProps] = useState({
    isOpen: false,
  })

  // Local state for editing - create a copy for editing
  const [currentData, setCurrentData] = useState(initialData)
  const [savedData, setSavedData] = useState(initialData)
  const [originalBaPerMission, setOriginalBaPerMission] = useState(
    DEFAULT_BA_PER_MISSION,
  )
  const [originalPayAdjustment, setOriginalPayAdjustment] = useState(
    DEFAULT_BA_PAY_ADJUSTMENT,
  )

  // Update data when initial data changes
  useEffect(() => {
    setCurrentData(initialData)
    setSavedData(initialData)
  }, [initialData])

  // When entering edit mode, save current values as original
  useEffect(() => {
    if (isEdit) {
      setOriginalBaPerMission(baPerMission)
      setOriginalPayAdjustment(payAdjustment)
      setSavedData(currentData)
    }
  }, [isEdit])

  const handleRowOpen = id => {
    setOpenedRow(prev => (prev === id ? null : id))
  }

  const handleBaPerMissionChange = value => {
    setBaPerMission(value)
  }

  const handlePayAdjustmentChange = value => {
    setPayAdjustment(value)
  }

  const onCloseModal = () => {
    setModalProps(prev => ({ ...prev, isOpen: false }))
  }

  return {
    // State
    openedRow,
    baPerMission,
    payAdjustment,
    modalProps,
    setModalProps,
    currentData,
    setCurrentData,
    savedData,
    setSavedData,
    originalBaPerMission,
    setOriginalBaPerMission,
    originalPayAdjustment,
    setOriginalPayAdjustment,
    // Handlers
    handleRowOpen,
    handleBaPerMissionChange,
    handlePayAdjustmentChange,
    onCloseModal,
  }
}
